interface ArcademicsBaseQnResponse {

  question: string;
  correct: 0 | 1;
  time: number;
}

interface ArcademicsMathQnResponse extends ArcademicsBaseQnResponse {
}

interface ArcademicsSpellingQnResponse extends ArcademicsBaseQnResponse {
}

type ArcademicsQnResponse = ArcademicsMathQnResponse | ArcademicsSpellingQnResponse

export interface ArcademicsResponse {
  time: number;
  responses: ArcademicsQnResponse[]
}

export class ArcademicsSummary {

  private _accuracy?: number = 0;
  private _totalAttempts?: number = 0;
  private _correctAttempts?: number = 0;
  private _totalTime: number = 0;

  constructor(private readonly data: ArcademicsResponse[]) {
  }

  compute() {

    if(this.data?.length === 0) {
      return;
    }

    let attemptsTotal =  0
    let attemptsCorrect = 0;
    let timeTotal = 0;

    for(const item of this.data) {
      attemptsTotal += item.responses.length || 0
      const responses = item.responses;
      timeTotal += item.time;

      responses.forEach(e => {
        if (e.correct) {
          attemptsCorrect++;
        }
      })
    }

    this._accuracy = Math.round(attemptsCorrect / attemptsTotal * 100);
    this._correctAttempts = attemptsCorrect;
    this._totalAttempts = attemptsTotal;
    this._totalTime = timeTotal;

  }

  get accuracy() {
    return this._accuracy
  }

  get totalAttempts() {
    return this._totalAttempts
  }

  get correctAttempts() {
    return this._correctAttempts
  }

  get totalTime() {
    return Math.round(this._totalTime / 1000);
  }
}